// Production builds alias 'msw' here (INT-1539). Mock handlers are built eagerly at import time
// by gqlQuery but only ever run under MSW in mock mode, so production gets inert builders instead
// of shipping MSW and its dependencies in the entry bundle.
const inertHandlerBuilder = new Proxy({}, { get: () => () => null })

export const graphql = inertHandlerBuilder
export const http = inertHandlerBuilder
